import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export function formatErr(detail) {
    if (detail == null) return "Something went wrong";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(", ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
